var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-grid-toolbar-item",on:{"click":_vm.onClick}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.name,"placement":"top"}},[_c('img',{attrs:{"src":_vm.icon}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7a729ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/data-grid/toolbar/item.vue
// module id = null
// module chunks = 